import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

interface SeeAllButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

const SeeAllButton: React.FC<SeeAllButtonProps> = ({ onClick, children }) => {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      className="flex items-center gap-1 text-sm font-semibold text-purple-400 hover:text-purple-300 transition-colors"
    >
      {children}
      <ChevronRight className="w-4 h-4" />
    </motion.button>
  );
};

export default SeeAllButton;
